import { createSlice } from '@reduxjs/toolkit'
import { copy } from '~/lib/utils'

const authSlice = createSlice({
	name: 'auth',
	initialState: {
		token: null,
		user: null,
	},
	reducers: {
		setAuth: (s, { payload }) => {
			s.token = payload.token
			const user = copy(payload.user)
			for (const a in user) {
				if (a.endsWith('roles')) {
					user.roles = user[a]
					delete user[a]
					break
				}
			}
			s.user = user
		},
		clearAuth: s => {
			s.token = null
			s.user = null
		},
	},
})

export const { setAuth, clearAuth } = authSlice.actions

export default authSlice.reducer
